import BaseApiService from './BaseApiService';
import { useUserStore } from '@/store_pinia/userStore';
import { getToken } from '@/services/utils/securityUtils';

class BaseMygocuApiService extends BaseApiService {
  constructor() {
    const AxiosSkiAndNightConfig = {
      baseURL: process.env.VUE_APP_MYGOCU_BASE_URL + process.env.VUE_APP_MYGOCU_API_BASE_PATH,
      withCredentials: process.env.NODE_ENV === 'development',
    };
    super(AxiosSkiAndNightConfig);
    
    this.axioInstance.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response.data;
      },
      async function (error) {
        if (error.response.data.code === 401 && getToken()) {
          useUserStore().logout(true);
        }
        return Promise.reject(error);
      }
    );
  }
}

export default new BaseMygocuApiService();
